import smoothscroll from "smoothscroll-polyfill";
import lozad from "lozad";
import hamburger from "./../part/hamburger";
import workSlider from "../part/workSlider";
import reframe from "reframe.js";
import videoCtrl from "../part/videoCtrl";

export default {
	init() {
		// JavaScript to be fired on all pages

		// kick off the polyfill!
		smoothscroll.polyfill();

		// Hamburger event listener
		hamburger();

		// Work Slider
		const caraouselSection = document.getElementById("workSlider");
		if (typeof caraouselSection != "undefined" && caraouselSection != null) {
			workSlider();
		}

		// Lazy load image with lozad.js https://github.com/ApoorvSaxena/lozad.js
		const observer = lozad(); // lazy loads elements with default selector as '.lozad'
		observer.observe();
	},

	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired

		// Reframe
		const theFrame = document.getElementById("videoFrame");
		if (typeof theFrame != "undefined" && theFrame != null) {
			reframe("iframe", "videoFrame");
			videoCtrl();
		}
	}
};
